window.onload = function() {

  // Video
  var video = document.getElementById("pacmanvideo");

  // Buttons
  var playButton = document.getElementById("pacmanvideo-play");

  if(playButton) {
    // Event listener for the play/pause button
    playButton.addEventListener("click", function() {
      if (video.paused == true) {
        // Play the video
        video.play();

        // Update the button text to 'Pause'
        $(playButton).attr('src','//cdn.shopify.com/s/files/1/0030/4227/9494/t/11/assets/video-pause.png?v=2931142822575407237');
        playButton.innerHTML = "Pause";
        $('.pacman-video-container .topoverlay').css({
          	'top': 'auto',
    		'left':'80px',
          	'bottom': '20px',
          	'width': '60px',
    		'height': '60px',
          	'opacity': '0.7'
        });
        $('.pacman-video-container .topoverlay img').css({
          	'max-width': '60px'
        });
      } else {
        // Pause the video
        video.pause();
          $(playButton).attr('src','//cdn.shopify.com/s/files/1/0030/4227/9494/t/11/assets/video-play.png?v=18227177898930698095');
        // Update the button text to 'Play'
        playButton.innerHTML = "Play";
        $('.pacman-video-container .topoverlay').css({
          	'top': '50%',
    		'left':'50%',
          	'bottom': 'auto',
            'width': '80px',
    		'height': '80px',
            'opacity': '1'
        });
        $('.pacman-video-container .topoverlay img').css({
          	'max-width': '80px'
        });
      }
    });
  }
}

$(document).ready(function () {
  $('.add-to-cart-form #product-select').on('change', function() {
    var variant_quantity = parseInt($(this).find('option:selected').attr('data-quantity'));
    $outofstock = $('#out-of-stock-gl');
    $addToCart = $('#shopify_add_to_cart');
    $variantQuantity = $('#variantQuantity')

    if(variant_quantity <= 0) {
      $addToCart.hide();
      $outofstock.show();
      $outofstock.css('margin-top','30px');
    } else {
      $addToCart.show();
      $outofstock.hide();
    }

    if (variant_quantity < 10 && variant_quantity > 0) {
      $variantQuantity.html(" Hurry, there are only 1 item(s) left!".replace('1', variant_quantity)).addClass('show');
    } else {
      $variantQuantity.removeClass('show');
    }
  });
  
  if($('.template-collection .basel-products-load-more').length > 0) {
    $(window).scroll(function () {
      if ($('.basel-products-load-more').visible(true)) {
        $('.basel-products-load-more:not(.loading)').trigger('click');
      }
    });
  }
  
  $('#header-checkout').on('click', function (e) {
    e.stopImmediatePropagation();
    window.location.href = '/cart';
  });
  
  $('.mobile_related_blockslider > .col-sm-4').matchHeight();
  
  $('#menu-main-navigation li.block_type_dropdown').each(function() {
    if($(this).hasClass('menu-item-shop-by-category')) {
      
    } else {
      if($(this).find('ul.sub-menu > li').length > 8) {
        $(this).addClass('submenu_links_wrapper');
        $(this).find('ul.sub-menu').append('<div class="left-wrapper"></div>');
        $(this).find('ul.sub-menu').append('<div class="right-wrapper"></div>');
        var count = $(this).find('ul.sub-menu > li').length;
        var result = Math.ceil(count / 2);
        var menu_counter = 0;
        $(this).find('ul.sub-menu > li').each(function(e){
          menu_counter++;
          if(menu_counter <= result) {
            $(this).appendTo($(this).parent().find('.left-wrapper'));
          } else {
            $(this).removeClass('links');
            $(this).addClass('links2');
            $(this).appendTo($(this).parent().find('.right-wrapper'));
          }
        });
      }
    }
  });

//   $('.main-header #menu-main-navigation > li.menu-item').each(function () {
//     var childs = $(this).find('.sub-menu > li').length;

//     if (childs > 9) {
//       $(this).addClass('submenu_links_wrapper');
//       $(this).find('.sub-menu').append('<div class="left-wrapper"></div>');
//       $(this).find(".links").appendTo($(this).find(".left-wrapper"));
//       $(this).find('.sub-menu').append('<div class="right-wrapper"></div>');
//       $(this).find(".links2").appendTo($(this).find(".right-wrapper"));
//     }
//   });

  $('li.thirdMenu-Wrapper > a').on('click', function (e) {
    e.preventDefault();
    return false;
  });

  if ($(window).width() <= 767) {
    $('.product_categoryWrapper .menu-item').unbind('click');
    $('.product_categoryWrapper .menu-item').click(function (e) {
      e.preventDefault();
      if ($(this).parent(".productCategory_LinksWrapper").hasClass('active')) {
        $(".category_mainwrapper").find(".productCategory_LinksWrapper").removeClass("active");
        $(".category_mainwrapper").find(".submenu_ProductCategory").slideUp();
      } else {
        $(".category_mainwrapper").find(".productCategory_LinksWrapper").removeClass("active");
        $(".category_mainwrapper").find(".submenu_ProductCategory").slideUp();

        $(this).parent(".productCategory_LinksWrapper").addClass("active");
        $(this).parent(".productCategory_LinksWrapper").find(".submenu_ProductCategory").slideDown();
      }
    });
  }else{
    $(".category_mainwrapper").find(".submenu_ProductCategory").show();
  }

  $('.message_wrapper').parents('.footer-column').addClass('none');
  $('.add-to-cart-form .variations .size_box').matchHeight();


  if ($(window).width() <= 767) {
    var heightToPut = $("header.main-header").height();
    $(".website-wrapper").css('padding-top', heightToPut + "px");
  }

  $(window).resize(function (e) {
    if ($(window).width() <= 767) {
      var heightToPut = $("header.main-header").height();
      $(".website-wrapper").css('padding-top', heightToPut + "px");
    }
  });


  if ($('.basel-products-holder').length > 0) {
    $('.basel-products-holder .product-grid-item').matchHeight();
    //     $('.basel-products-holder .product-grid-item .product-element-top img').matchHeight();
    //     $('.basel-products-holder .product-grid-item .product-title').matchHeight();
  }

  $('.block_type_mega_sub > a').on('click', function (e) {
    if ($(this).attr('href') != '') {

    } else {
      e.preventDefault();
    }
  });

  if (jQuery(window).width() < 768) {
    $("#blog_category").select2({
      minimumResultsForSearch: -1
    });

    $("#blog_category").on('change', function () {
      var redirect_url = $('this').val();
      window.location = redirect_url;
    });

    $(document).on('click', '.mob_filter_wrapper li a', function (e) {
      e.preventDefault();
      var href = $(this).attr('href');

      if ($(this).hasClass('active')) {
        $(".mob_filter_wrapper").find("li a").removeClass("active");
        $(".sorting_mob_wrapper").slideUp(500);
      } else {
        $(".mob_filter_wrapper").find("li a").removeClass("active");
        $(".sorting_mob_wrapper").slideUp(500);

        $(this).addClass("active");
        $(href).slideDown(500);
      }
    });


    $('.mobile_related_blockslider').slick({
      slidesToShow: 1,
      infinite: false,
      dots: true,
      arrows: false,
      slidesToScroll: 1
    });

    /**** STARTS JS FOR PRODUCT TOGGLE ACCORDION *******/
    $('.produc_tab_block .product_info_name').unbind('click');
    $('.produc_tab_block .product_info_name').click(function (e) {
      e.preventDefault();
      if ($(this).parents(".produc_tab_block").hasClass('active')) {
        $(".tab_for_productsection").find(".produc_tab_block").removeClass("active");
        $(".tab_for_productsection").find(".sub_category").slideUp();
      } else {
        $(".tab_for_productsection").find(".produc_tab_block").removeClass("active");
        $(".tab_for_productsection").find(".sub_category").slideUp();

        $(this).parents(".produc_tab_block").addClass("active");
        $(this).parents(".produc_tab_block").find(".sub_category").slideDown();
      }
    });
    /**** ENDS JS FOR PRODUCT TOGGLE ACCORDION *******/

    /**** STARTS JS FOR FOOTER TOGGLE ACCORDION *******/

    $('.footer-sidebar').find('.footer-column').addClass('footer_section_toggle');
    $('.footer-sidebar').find('.footer-column').last().removeClass('footer_section_toggle');
    $('.footer-sidebar .widget-title').unbind('click');
    $('.footer-sidebar .widget-title').click(function (e) {
      e.preventDefault();
      if ($(this).parents(".footer_section_toggle").hasClass('active')) {
        $(".footer-sidebar").find(".footer_section_toggle").removeClass("active");
        $(".footer-sidebar").find(".footer_section_toggle").find(".textwidget").slideUp();
      } else {
        $(".footer-sidebar").find(".footer_section_toggle").removeClass("active");
        $(".footer-sidebar").find(".footer_section_toggle").find(".textwidget").slideUp();

        $(this).parents(".footer_section_toggle").addClass("active");
        $(this).parents(".footer_section_toggle").find(".textwidget").slideDown();
      }
    });
    /**** ENDS JS FOR FOOTER TOGGLE ACCORDION *******/
  } else {
//     $('.product_description.hidden-for-mobile').showMore({
//       minheight: 90,
//       buttontxtmore: 'READ MORE',
//       buttontxtless: 'READ LESS',
//       animationspeed: 250
//     });
  }


  $('.slider_product_1 .element_wrapper .tab_block').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false
        }
      },
    ]
  });

  $('.slider_product_2 .element_wrapper .tab_block').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false
        }
      },
    ]
  });


  $('.product_tabs .gl_tta-tab a').on('click', function (e) {
    e.preventDefault();

    $('.slider_product_1 .element_wrapper .tab_block').slick('unslick');
    $('.slider_product_1 .element_wrapper .tab_block').slick({
      slidesToShow: 4,
      infinite: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        },
      ]
    });


    $('.like_btn').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('like');
    });

    if ($('.like_btn').hasClass('like')) {
    } else {
      $(".like_btn").hover(
        function () {
          $(this).toggleClass('like');
        },
        function () {
          $(this).toggleClass('like');
        }
      );
    }
  });

//   $('.product_read_more').on('click', function (e) {
//     e.preventDefault();
//     $('.product_description').addClass('show');
//     $(this).addClass('hidden');
//   });

  $('form[name="contact_form"] .submit_btn').on('click', function (e) {
    e.preventDefault();
    if ($("form[name='contact_form']").valid()) {
      $("form[name='contact_form']").submit();
    }
  });
  
  $("form[name='contact_form']").validate({
    rules: {
      name: "required",
      email: {
        required: true,
        email: true
      },
      message: "required"
    },
    messages: {
      name: "Please enter your name",
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
      },
      message: "Message is required"
    }
  });
  
  $('form[name="contact_form_mobile"] .submit_btn').on('click', function (e) {
    e.preventDefault();
    if ($("form[name='contact_form_mobile']").valid()) {
      $("form[name='contact_form_mobile']").submit();
    }
  });
  
  $("form[name='contact_form_mobile']").validate({
    rules: {
      name: "required",
      email: {
        required: true,
        email: true
      },
      message: "required"
    },
    messages: {
      name: "Please enter your name",
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
      },
      message: "Message is required"
    }
  });


  $('.select_category .arrow').click(function (e) {
    e.preventDefault();
    if ($(this).parents(".product_category").hasClass('active')) {
      $(".category_wrapper").find(".product_category").removeClass("active");
      $(".category_wrapper").find(".product_subcategory").slideUp();
    } else {
      $(".category_wrapper").find(".product_category").removeClass("active");
      $(".category_wrapper").find(".product_subcategory").slideUp();

      $(this).parents(".product_category").addClass("active");
      $(this).parents(".product_category").find(".product_subcategory").slideDown();
    }
  });


  /********* ADD ACTIVE CLASS IN NAVIGATION *********/
  var current_page_url = window.location.href;
  $('#menu-main-navigation').find('li').eq(0).addClass('active');


  if (current_page_url.indexOf('/collections/') !== -1) {
    $('#menu-main-navigation li').each(function (index, element) {
      var menu_link = $(this).find('a').attr('href');
      if (menu_link.indexOf("/collections/") !== -1) {
        $('#menu-main-navigation li').removeClass('active');
        $(this).addClass('active');
      }
    });

  }

  if (current_page_url.indexOf('/products/') !== -1) {
    $('#menu-main-navigation li').each(function (index, element) {
      var menu_link = $(this).find('a').attr('href');
      if (menu_link.indexOf("/products/") !== -1) {
        $('#menu-main-navigation li').removeClass('active');
        $(this).addClass('active');
      }
    });

  }

  /********* ENDS ADD ACTIVE CLASS IN NAVIGATION *********/

  $(".gl_tta-tab").matchHeight();

  $('.product_tabs li a').on('click', function (e) {
    $('.product_slider .product_tab_block').slick('unslick');
    $('.product_slider .product_tab_block').slick({
      //       infinite: false,
      //       slidesToShow: 4,
      //       slidesToScroll: 1
    });
  });



  $('.like_btn').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('like');
  });



  if ($('.like_btn').hasClass('like')) {
  } else {
    $(".like_btn").hover(
      function () {
        $(this).toggleClass('like');
      },
      function () {
        $(this).toggleClass('like');
      }
    );
  }


  $('.chk-box').iCheck({
    checkboxClass: 'checkbox_input'
  });

  $("#sort_by").select2({
    placeholder: "Select a State"
  });


  $('.share_gallery .share_btn > a').on('click', function (e) {
    e.preventDefault();
    $(this).parent('li').find('.socialGallery').toggleClass('display');



    //     $.fn.matchHeight._afterUpdate = function(event, groups) {
    //       $('.blog_block_image').each(function() {
    //         var image_url = $(this).find('img').attr('src');
    //         if (image_url) {
    //           $(this).backstretch(image_url);
    //           $(this).find('img').css('display', 'none');
    //         }
    //       });
    //     }
  });



  /************ STARTS JS FOR HOME PRODUCT SECTION SLIDEDOWN ************/
  $("div.blog_box").slice(0, 6).show();
  $(".load_blocks_wrapper .load_btn").on('click', function (e) {
    e.preventDefault();
    $("div.blog_box:hidden").slice(0, 6).slideDown();
    if ($("div.blog_box:hidden").length == 0) {
      $(".load_blocks_wrapper .load_btn").fadeOut('slow');
    }

    $('.blog_block_image').each(function () {
      var image_url = $(this).find('img').attr('src');
      if (image_url) {
        $(this).backstretch(image_url);
        $(this).find('img').css('display', 'none');
      }
    });


  });
  /************ ENDS JS FOR HOME PRODUCT SECTION SLIDEDOWN ************/
  $('.product_tab_block .product_block_wrapper').matchHeight();
  $('.product_tabs .gl_tta-tab').matchHeight();


  /************ STARTS JS FOR FAQ TABS ************/
  $('.block_tabs li.tab_toggle > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent("li.tab_toggle").hasClass('active')) {
      $(".block_tabs").find("li").removeClass("active");
      $(".block_tabs").find(".sub-menu").slideUp();
    } else {
      $(".block_tabs").find("li").removeClass("active");
      $(".block_tabs").find(".sub-menu").slideUp();

      $(this).parent("li.tab_toggle").addClass("active");
      $(this).parent("li.tab_toggle").find(".sub-menu").slideDown();
    }
  });
  /************ ENDS JS FOR FAQ TABS ************/
});

$(window).load(function () {
  if ($('.basel-products-holder').length > 0) {
    $('.basel-products-holder .product-grid-item').matchHeight();
    //     $('.basel-products-holder .product-grid-item .product-element-top img').matchHeight();
    //     $('.basel-products-holder .product-grid-item .product-title').matchHeight();
  }
  
  if ($(window).width() <= 767) {
    $(".sub_category").css("display", "none");
  }else{
  	$('.catogory_FullWrapper > .spb_column').matchHeight();
  }
  
  /***** starts js for product page height ******/
  if (('.template-product').length > 0) {
    var contact_height = $('.need_help_block').height();
  }

  $('#recently-viewed-products .like_btn').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('like');
  });
  if ($('#recently-viewed-products .like_btn').hasClass('like')) {
  } else {
    $("#recently-viewed-products .like_btn").hover(
      function () {
        $(this).toggleClass('like');
      },
      function () {
        $(this).toggleClass('like');
      }
    );
  }

  if ($(window).width() > 767) {
    $('.blog_block_image').matchHeight({
      byRow: true
    });

    $.fn.matchHeight._afterUpdate = function (event, groups) {
      $('.blog_block_image').each(function () {
        var image_url = $(this).find('img').attr('src');
        if (image_url) {
          $(this).backstretch(image_url);
          $(this).find('img').css('display', 'none');
        }
      });
    }
  }
});

var currentPriceArray = Array();
var max_price_filter = 0;
var min_price_filter = 0;
$(document).ready(function (e) {
  if ($("#slider_price").length > 0) {
    $(".price").each(function (index, element) {
      if ($(element).text().indexOf('–') !== -1) {
        var currentParts = $(element).text().split("–");
        var value1 = parseFloat(currentParts[0].replace('£', ''));
        var value2 = parseFloat(currentParts[1].replace('£', ''));
        currentPriceArray.push(value1);
        currentPriceArray.push(value2);
      } else {
        var value1 = parseFloat($(element).text().replace('£', ''));
        currentPriceArray.push(value1);
      }
    });

    min_price_filter = Math.min.apply(null, currentPriceArray);
    max_price_filter = Math.max.apply(null, currentPriceArray);

    if (min_price_filter != max_price_filter) {
      $("#slider_price").slider({
        range: true,
        min: min_price_filter,
        max: max_price_filter,
        values: [min_price_filter, max_price_filter],
        slide: function (event, ui) {
          $("#price").val("$" + ui.values[0]);
          $("#price_max").val("$" + ui.values[1]);
        }
      });

      $("#price").val("$" + $("#slider_price").slider("values", 0));
      $("#price_max").val("$" + $("#slider_price").slider("values", 1));

      $("#slider_price").on("slidechange", function (event, ui) {
        $("body").addClass("basel-loading");
        $(".price-filtered-hidden").removeClass('price-filtered-hidden');

        var selected_min = $('#slider_price').slider("values", 0);
        var selected_max = $('#slider_price').slider("values", 1);

        $(".wrap-price .price").each(function (index, element) {
          if ($(element).text().indexOf('–') !== -1) {
            var currentParts = $(element).text().split("–");
            var value1 = parseFloat(currentParts[0].replace('£', ''));
            var value2 = parseFloat(currentParts[1].replace('£', ''));

            if ((value1 >= selected_min && value1 <= selected_max) || (value2 >= selected_min && value2 <= selected_max)) {
              //do nothing
            } else {
              $(element).parents('.product-grid-item').eq(0).addClass('price-filtered-hidden');
            }

          } else {
            var value1 = parseFloat($(element).text().replace('£', ''));
            if (value1 >= selected_min && value1 <= selected_max) {
              //do nothing
            } else {
              $(element).parents('.product-grid-item').eq(0).addClass('price-filtered-hidden');
            }

          }
        });

        setTimeout(function () {
          $('.basel-products-holder .product-grid-item').not('.price-filtered-hidden').matchHeight();
          $("body").removeClass("basel-loading");
        }, 1000);
      });
    } else {
      $('#BASEL_Widget_Price_Filter').hide();
    }
  }

  $('.current-state').each(function (index, element) {
    $(element).siblings('.checkbox_input').find('input').iCheck('check');
  });

  $('li.chosen').each(function (index, element) {
    $(element).find('.checkbox_input').find('input').iCheck('check');
  });

  $(document).on('click', '.chk-box > a', function (e) {
    var __this = e.target;
    $(__this).siblings('.checkbox_input').find('input').iCheck('toggle');
  });

  $(document).on('ifClicked', '.checkbox_input > input', function (e) {
    var __this = e.target;
    $(__this).parents('.checkbox_input').eq(0).siblings('a').trigger('click');
  });

  $(document).on('click', 'li.menu-item-has-children > a', function (e) {
    e.preventDefault();
    return false;

  });

  $('.info-tab-single').matchHeight();
});

$(window).resize(function () {
  if ($(window).width() <= 767) {
    	$('.product_categoryWrapper .menu-item').unbind('click');
      $(".category_mainwrapper").find(".submenu_ProductCategory").hide();
      $('.product_categoryWrapper .menu-item').click(function (e) {
        e.preventDefault();
        if ($(this).parent(".productCategory_LinksWrapper").hasClass('active')) {
          $(".category_mainwrapper").find(".productCategory_LinksWrapper").removeClass("active");
          $(".category_mainwrapper").find(".submenu_ProductCategory").slideUp();
        } else {
          $(".category_mainwrapper").find(".productCategory_LinksWrapper").removeClass("active");
          $(".category_mainwrapper").find(".submenu_ProductCategory").slideUp();

          $(this).parent(".productCategory_LinksWrapper").addClass("active");
          $(this).parent(".productCategory_LinksWrapper").find(".submenu_ProductCategory").slideDown();
        }
      });
  }else{
    $(".category_mainwrapper").find(".submenu_ProductCategory").show();
  }
});
  


$(window).resize(function () {
  if ($(window).width() <= 767) {

    $('.footer-sidebar').find('.footer-column').addClass('footer_section_toggle');
    $('.footer-sidebar').find('.footer-column').last().removeClass('footer_section_toggle');
    $('.footer-sidebar .widget-title').unbind('click');
    $('.footer-sidebar .widget-title').click(function (e) {
      e.preventDefault();
      if ($(this).parents(".footer_section_toggle").hasClass('active')) {
        $(".footer-sidebar").find(".footer_section_toggle").removeClass("active");
        $(".footer-sidebar").find(".footer_section_toggle").find(".textwidget").slideUp();
      } else {
        $(".footer-sidebar").find(".footer_section_toggle").removeClass("active");
        $(".footer-sidebar").find(".footer_section_toggle").find(".textwidget").slideUp();

        $(this).parents(".footer_section_toggle").addClass("active");
        $(this).parents(".footer_section_toggle").find(".textwidget").slideDown();
      }
    });


    /**** STARTS JS FOR PRODUCT TOGGLE ACCORDION *******/
    $('.produc_tab_block .product_info_name').unbind('click');
    $('.produc_tab_block .product_info_name').click(function (e) {
      e.preventDefault();
      if ($(this).parents(".produc_tab_block").hasClass('active')) {
        $(".tab_for_productsection").find(".produc_tab_block").removeClass("active");
        $(".tab_for_productsection").find(".sub_category").slideUp();
      } else {
        $(".tab_for_productsection").find(".produc_tab_block").removeClass("active");
        $(".tab_for_productsection").find(".sub_category").slideUp();

        $(this).parents(".produc_tab_block").addClass("active");
        $(this).parents(".produc_tab_block").find(".sub_category").slideDown();
      }
    });
    var active_Link = $('.tab_for_productsection li.active a').attr('href');
    $(active_Link).hide();
    /**** ENDS JS FOR PRODUCT TOGGLE ACCORDION *******/
  } else {
    $('.footer-sidebar').find('.footer-column').removeClass('footer_section_toggle');

    $(".footer-sidebar").find(".textwidget").show();
    //     $(".footer-sidebar").find(".footer_section_toggle").find(".textwidget").slideDown();

    var active_Link = $('.tab_for_productsection li.active a').attr('href');
    $(active_Link).show();

  }
});

$(window).on('load', function () {
  $('a.Mobile_cart').on('click', function (e) {
      e.stopImmediatePropagation();
      window.location.href = '/cart';
  });
  
  setTimeout(function () {
    if ($('.spr-summary-actions-togglereviews').length > 0) {
      $('.spr-summary-actions-togglereviews').trigger('click');
    }
  }, 5000);
});

$(document).ready(function(e){
  
  if($('.threedee-container').length > 0) {
    $('.pacman-back-button').on('click', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      $('html, body').animate({
        scrollTop: $(href).offset().top - 200
      }, 1000);
    });
  }
  
  $('.shopify-product-gallery .shopify-product-gallery__image').each(function() {
    var altX = $(this).attr('data-alt');
    var str = 'youtube';
    if (altX.indexOf(str) > -1) {
      $(this).append('<a class="play_button" data-fancybox href="'+ altX +'"><img src="//cdn.shopify.com/s/files/1/0030/4227/9494/t/11/assets/play-button.svg?7144"/></a>');
      $('[data-fancybox]').fancybox({
        
    });

    }
  });
  
  

//   $(".threedee-container,.rightcontainer-pacman-bottom").matchHeight();

//   $(document).on('click','.topoverlay',function(e){
//     var myVideo = document.getElementById("pacmanvideo");
//     myVideo.play();
//     $('.topoverlay').fadeOut(100);
//   });
  
//   if($(window).width() < 768){
//       $(".embed-responsive>iframe").css('min-width',($(".embed-responsive").width()-30) );
//       $(".embed-responsive>iframe").css('height',($(".embed-responsive").width()-30) );
//     }
//     else{
//        $(".embed-responsive>iframe").css('min-width','' );
//       $(".embed-responsive>iframe").css('width',($(".threedee-container").width()-30));
//      $(".embed-responsive>iframe").css('height',($(".threedee-container").width()-30));
//     }
//   $(window).on("resize",function(){
//     if($(window).width() < 768){
//       $(".embed-responsive>iframe").css('min-width',($(".embed-responsive").width()-30) );
//       $(".embed-responsive>iframe").css('height',($(".embed-responsive").width()-30) );
//     }
//     else{
//        $(".embed-responsive>iframe").css('min-width','' );
//       $(".embed-responsive>iframe").css('width',($(".threedee-container").width()-30));
//      $(".embed-responsive>iframe").css('height',($(".threedee-container").width()-30));
//     }
//   });

  // 14-12-18 update js
  $('.pacman-page-area .sameheight').matchHeight();
  $('.pacman-page-area .sameheight_inner').matchHeight();
  $('.slider-embed_wrapper_pacman-area .sameheight_slider').matchHeight();

  // $('.sameheight_slider').on('init', function(event, slick){
  //   $(this).find('.slick-slide').height('auto');
  //                         var slickTrack = $(this).find('.slick-track');
  //                         console.log($(slickTrack).outerHeight());
  //                         var slickTrackHeight = $(slickTrack).height();
  //                         $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
  //     console.log("initialised")
  // });


  $('.watch_video > a').fancybox();

  $('.slider_owl').slick({
    slidesToShow: 1,
    infinite: false,
    dots: true,
    arrows: true,
    slidesToScroll: 1,
    autoplay: true
  });
});

$(document).ready(function($) {
  $('.accordion-faqs-menu').find('.title_heading').click(function(){
    //Expand or collapse this panel
    $(this).toggleClass('open');
    $(this).next().slideToggle('');
    //Hide the other panels
    $(".accordion-faqs-content").not($(this).next()).slideUp('');
  });
  // $('.accordion-faqs-menu').find('.accordion-faqs-toggle2').click(function(){
  //   //Expand or collapse this panel
  //   $(this).toggleClass('open');
  //   $(this).next().slideToggle('fast');
  //   //Hide the other panels
  //   $(".accordion-faqs-content2").not($(this).next()).slideUp('fast');
  // }); 
});

//=========03 Jan 2019 Features update js starts=======
$(window).resize(function () {
  $(window).scroll(function () {
    if($(window).width() < 992)
    {
      var scrolllength = $(window).scrollTop(); 
      var headerHeight = $("header.main-header > .container").height();
      if(scrolllength > headerHeight) {
        $("header.main-header > .container").addClass("customStickyHeader");
      }
      else
      {
        $("header.main-header > .container").removeClass("customStickyHeader");
      }  
    }
  });
});
$(window).scroll(function () {
  if($(window).width() < 992) {
    var scrolllength = $(window).scrollTop(); 
    var headerHeight = $("header.main-header > .container").height();
    if(scrolllength > headerHeight)
    {
      $("header.main-header > .container").addClass("customStickyHeader");
    }
    else
    {
      $("header.main-header > .container").removeClass("customStickyHeader");
    }  
  }
});

/*=========09 Feb 2019 Product page changes start =====*/

$(document).ready(function() {
  if($(window).width() < 768) {
    $('.collection_page .related_product_gallery').matchHeight();
  }
  $(document).on('click','#shopify_quantity .quantity-minus',function(e) {
    e.preventDefault();
    var quantity = parseInt($(this).next().val());
    if(quantity > 1) {
      quantity = quantity - 1;
    } else {
      quantity = 1;
    }
    $(this).next().val(quantity);
  });

  $(document).on('click','#shopify_quantity .quantity-plus',function(e) {
    e.preventDefault();
    var quantity = parseInt($(this).prev().val());
    quantity = quantity + 1;
    $(this).prev().val(quantity);
  });

  if($('.about-content-info').length > 0) {
    if($(window).width() > 991) {
      $('.about-content-info > .col-sm-4 > .img').matchHeight();
      $('.about-content-info > .col-sm-4').matchHeight();
    }
  }

  $('.pacman-back-footer > ul').slick({
    slidesToShow: 5,
    infinite: false,
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  }); 
});

/*=========09 Feb 2019 Product page changes end =======*/

/*========= 10 Apr 2019 geo bar changes start =======*/
$(window).on("scroll", function() {
  if($('#geoip-banner').length > 0) {
    var scrollPosition = $(window).scrollTop();
    if(scrollPosition > 35) {
      $('.topbar-wrapp.hidden-for-mobile').css('top','0');
    } else {
      $('.topbar-wrapp.hidden-for-mobile').css('top','auto');
    }
  }
});
/*========= 10 Apr 2019 geo bar changes end =======*/

/* 20 Jun 2019 Match Height Galaga starts */
$(window).on("load", function() {
  if($(window).width() >= 768) {
    if($('.galaga-matchheight').length > 0) {
      $('.galaga-matchheight').matchHeight();
    }
  }
});
/* 20 Jun 2019 Match Height Galaga ends */